import React, { useContext, useEffect } from 'react';
import { CollapseProvider } from '@uhg-abyss/web/ui/CollapseProvider';
import { useGetProcStatsQuery } from '@src/store/services/cdb/onlineServices';
import { useGetGPSProcStatsQuery } from '@src/store/services/gps/onlineServices';
import { LoadingScreen } from '@src/common/LoadingScreen';
import { RecordCount } from './RecordCount';
import { FCHTransCount } from './FCHTransCount';
import { ErrorAndWarningCount } from './ErrorAndWarningCount';
import { ErrorTransCount } from './ErrorTransCount';
import { PCPRolloverCount } from './PCPRolloverCount';
import { SuccessTransCount } from './SuccessTransCount';
import { GPSStatusCount } from './GPSStatusCount';
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import { FileContext } from '@src/routes/Routes';

export const ProcessingStats = ({ setId, onChildValueChange }) => {
  const router = useRouter();
  const { service } = router.getRouteParams();
  const { setFileData } = useContext(FileContext);
  const {
    data: procStatsList,
    isLoading,
    refetch,
  } = service === 'gps'
    ? useGetGPSProcStatsQuery(setId)
    : useGetProcStatsQuery(setId);

  // Force refetch when component mounts or setId changes
  useEffect(() => {
    refetch();
  }, [setId, refetch]);

  if (isLoading) {
    return <LoadingScreen />;
  }
  return (
    <CollapseProvider defaultIsOpen={true}>
      <CollapseProvider.Button
        css={{
          'abyss-collapse-button-root': {
            display: 'flex',
            minHeight: '45px',
            padding: '0 20px',
            justifyContent: 'space-between',
            '.abyss-text-root': {
              color: '$web.semantic.color.text.content.primary',
              fontSize: '18px',
              fontWeight: 'bold',
            },
          },
        }}
      />
      <RecordCount procStatsList={procStatsList} service={service} />
      <SuccessTransCount
        procStatsList={procStatsList}
        onChildValueChange={onChildValueChange}
        service={service}
      />
      <ErrorTransCount
        procStatsList={procStatsList}
        onChildValueChange={onChildValueChange}
        service={service}
      />
      <ErrorAndWarningCount
        procStatsList={procStatsList}
        onChildValueChange={onChildValueChange}
        service={service}
      />
      {service !== 'gps' && (
        <PCPRolloverCount
          procStatsList={procStatsList}
          onChildValueChange={onChildValueChange}
        />
      )}

      {service == 'gps' && (
        <GPSStatusCount
          procStatsList={procStatsList}
          onChildValueChange={onChildValueChange}
        />
      )}

      <FCHTransCount
        onChildValueChange={onChildValueChange}
        service={service}
      />
    </CollapseProvider>
  );
};
